import CustomisedButton from "../../button/button"
import { ISplitedWithButtonCard } from "./ISplitedWithButtonCard"

const SplitedWithButtonCard = ({ firstRowDescription, secondRowDescription, buttonTitle, onClick, title }: ISplitedWithButtonCard) => {
    return (
        <div className='p-5 flex flex-col justify-start align-top gap-4  rounded-lg border border-[var(--border-color)] bg-[var(--input-bg-color)]'>
            <div className='flex flex-col gap-2'>
                <div className='text-[var(--primary-text-color)] text-[.9rem] '>{title}</div>
                <div className='text-[var(--text-gray-color)] text-[1.1rem] text-end'>{firstRowDescription}</div>
            </div>
            <hr className="grayLine" />
            <div className='flex flex-col gap-2'>
                <div className='text-[var(--primary-text-color)] text-[.9rem] '>{secondRowDescription}</div>
                <div className='flex justify-end w-full'>
                    <div className="w-1/2">
                        <CustomisedButton title={buttonTitle} onClick={onClick} disable={false} type={"button"} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SplitedWithButtonCard